import './vaccine-tracker.css';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ListItem } from '@/components/ui/atoms/MListItem';
import { formatWeeksToAge } from '@/utils/date-utils';
import { getMemberInfo } from '@/hooks/useMembers';
import { useVaccinationSuggestions } from '@/hooks/useVaccinationSuggestions';
import FormHeader from '@/components/ui/organisms/MHeader';
import { getMemberName } from '@/utils/member';
import { useNavigate } from 'react-router-dom';
import { appendToPath } from '@/utils/nav-utils';
import MLoader from '@/components/ui/atoms/MLoader';

/**
 * Component for displaying age-appropriate suggested vaccines
 */
const SuggestedVaccines: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const memberInfo = getMemberInfo();
  const memberId = memberInfo.id;
  const name = getMemberName(memberInfo);

  const {
    suggestedVaccinations,
    fetchSuggestions,
    loading
  } = useVaccinationSuggestions(memberId);

  const onSelectVaccine = (vaccineName: string) => {
    navigate(appendToPath(location.pathname, 'add-vaccine'), { state: { vaccineName } });
  };

  useEffect(() => {
    fetchSuggestions();
  }, []);

  if (loading) {
    return (
      <MLoader />
    );
  }

  return (
    <div className="profile-page-root">

      {/* Header */}
      <FormHeader
        title={t('vaccinations.suggested.title')}
        description={t('vaccinations.suggested.description', { name })}
        learnMoreContent={t('vaccinations.suggested.learn-more-text')}
        module="vaccinations"
        memberInfo={memberInfo}
      />

      {/* Vaccinations List */}
      <>
        {suggestedVaccinations.length === 0 ? (
          <div className="profile-flex-col-gap">
            <p>{t('vaccinations.suggested.empty')}</p>
          </div>
        ) : (
          <div className="profile-flex-col-gap">
            {suggestedVaccinations.map((vaccination, index) => (
              <ListItem
                key={`${vaccination.name}-${index}`}
                title={vaccination.name}
                variant="purple"
                secondaryText={formatWeeksToAge(vaccination.age)}
                usage="crud"
                type="2-line"
                onClick={() => onSelectVaccine(vaccination.name)}
              />
            ))}
          </div>
        )}
      </>
    </div>
  );
};

export default SuggestedVaccines;
